@if (isPsicTheme) {
  <div class="psic-footer-image-container d-none d-md-block" style="min-height: 153px"></div>
}
@if (!isPsicTheme) {
  <div class="footer-image-container d-none d-md-block" style="min-height: 153px"></div>
}
